module.exports = __webpack_public_path__ + "static/media/endeavor.e528099e.png";